import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=82a4b404&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "../../style/common-m.scss?vue&type=style&index=0&id=82a4b404&prod&lang=scss&scoped=true&external"
import style1 from "./orderList.vue?vue&type=style&index=1&id=82a4b404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a4b404",
  null
  
)

export default component.exports